import {CustomFieldProfileEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {CustomFieldProfileAction} from "./CustomFieldProfileActionMenu";
import {useCustomFieldProfileMutation} from "../../../hooks/useCustomFieldProfileMutation";

export type UseCustomFieldProfileActionProps = {}

export type UseCustomFieldProfileActionResult = {
  onCustomFieldProfileActionClick: (customFieldProfile: CustomFieldProfileEntity, action: CustomFieldProfileAction) => void;
}

export const useCustomFieldProfileAction = (props: UseCustomFieldProfileActionProps = {}): UseCustomFieldProfileActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteCustomFieldProfile,
  } = useCustomFieldProfileMutation()

  const _onCustomFieldProfileActionClick = useCallback((customFieldProfile: CustomFieldProfileEntity, action: CustomFieldProfileAction) => {
    if (action === "EDIT") {
      navigate(`/custom-field-profiles/form`, {state: {id: customFieldProfile.id}})
    } else if (action === "DELETE") {
      deleteCustomFieldProfile(customFieldProfile.id, undefined)
    }
  }, [navigate, deleteCustomFieldProfile])

  return {
    onCustomFieldProfileActionClick: _onCustomFieldProfileActionClick
  }
}
